import { forwardRef, type ComponentPropsWithoutRef, type Ref } from "react";

import { ITEMS } from "common/form/fields/timezone";
import type { AriaRequired } from "common/core/form/error";
import { Select } from "common/core/form/select";

type Props = AriaRequired<ComponentPropsWithoutRef<"select">>;

function TimezoneField({ ...selectProps }: Props, ref: Ref<HTMLSelectElement>) {
  return <Select {...selectProps} items={ITEMS} ref={ref} />;
}

const TimezoneFieldWithRef = forwardRef(TimezoneField);

export default TimezoneFieldWithRef;
